// Lazy loader for the vendored pdf-lib UMD build (frontend/public/vendor/pdf-lib.min.js).
// Used by the W-9, agreements and MnDOT form features. No CDN, no bundler import:
// the file is served by the app itself and loaded once, on first use.
let _pdfLibPromise = null;

export function loadPdfLib() {
  if (typeof window !== "undefined" && window.PDFLib) return Promise.resolve(window.PDFLib);
  if (_pdfLibPromise) return _pdfLibPromise;
  _pdfLibPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/vendor/pdf-lib.min.js";
    s.async = true;
    s.onload = () => (window.PDFLib ? resolve(window.PDFLib) : reject(new Error("pdf-lib did not initialise")));
    s.onerror = () => reject(new Error("Could not load the PDF library. Check your connection and try again."));
    document.head.appendChild(s);
  });
  return _pdfLibPromise;
}
